<template>
    <div>
        <v-app-bar
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            app
            color="primary"
            dark
        >
        
            <div class="d-flex align-center">
                <a href="/">
                    <v-img
                        alt="Vuetify Logo"
                        class="shrink mr-2"
                        contain
                        src="../assets/manducaLogoBlanco.jpg.png"
                        transition="scale-transition"
                        width="40"
                    />
                </a>
                <span class="hidden-sm-and-down">Manduca Café - Bar</span>
            </div>

            <v-spacer></v-spacer>
            <div class="d-flex align-right">
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            </div>
        </v-app-bar>
        <Navigation :drawer="drawer" />
      </div>
</template>
<script>
import Navigation from '@/components/Navigation'

export default {
    name: 'Header',
    data: () => ({
        drawer: false,
    }),
    components: {
        Navigation
    }
}
</script>